(ns ui.view.counterparty-diligence.responder-form.nationality-list-editor
  (:require
   [common.country :as country]
   [common.localization :as loc]
   [common.util :as cu]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.view.counterparty-diligence.responder-form.event :as event]
   [ui.view.counterparty-diligence.responder-form.sub :as sub]
   [ui.view.counterparty-diligence.responder-form.validation-error-text :as error-text]))

(defn- change-rows!
  [{:keys [field section-id state-path]} new-rows]
  (rf/dispatch-sync [::event/change-field-value
                     {:value      (vec new-rows)
                      :field      field
                      :section-id section-id
                      :state-path state-path}]))

(defn- nationality-row
  [{:keys [row index rows lang-kw read-only? row-validation-errors
           show-validation-errors? can-remove-row? on-blur]
    :as   args}]
  (let [country-options (->> (country/localized-options lang-kw)
                             (mapv (fn [opt]
                                     {:value (:keyword opt)
                                      :label (:label opt)})))
        update-row (fn [row-key new-value]
                     (change-rows! args (assoc-in (vec rows) [index row-key] new-value)))]
    [:div
     {:class "flex gap-2 items-stretch"}
     [:div
      {:class "grow flex flex-col gap-1"}
      [labelled-input/view
       {:label       (loc/tr :nationality nil lang-kw)
        :editor-type :editor.type/select
        :value       (->> country-options
                          (cu/filter-by :value (:nationality row))
                          (first))
        :options     country-options
        :disabled?   read-only?
        :on-change   (fn [selected-value _selected-option]
                       (update-row :nationality selected-value)
                       (on-blur nil))}]
      (when show-validation-errors?
        [error-text/view
         {:validation-errors (get row-validation-errors :nationality)}])]

     [:div
      {:class "grow flex flex-col gap-1"}
      [labelled-input/view
       {:label     (loc/tr :national-id-number nil lang-kw)
        :data-type :data.type/text-simple
        :value     (:id-number row)
        :disabled? read-only?
        :on-change (fn [new-value]
                     (update-row :id-number new-value))
        :on-blur   on-blur}]
      (when show-validation-errors?
        [error-text/view
         {:validation-errors (get row-validation-errors :id-number)}])]

     (when-not read-only?
       [:div
        {:class "pt-8"}
        [button/square-secondary-open
         {:on-click  (fn [_]
                       (change-rows! args
                                     (concat (take index rows)
                                             (drop (inc index) rows)))
                       (on-blur nil))
          :disabled? (not can-remove-row?)}
         [:i.fal.fa-trash]]])]))

(defn view
  "Repeatable nationality + national ID number rows. When the field has no
   value yet, rows fall back to the legacy single :person/nationality +
   :person/national-identification-number answers so processes saved before
   the multi-nationality field keep their data."
  [{:keys [field value section-id state-path answers-path lang-kw read-only?
           validation-errors show-validation-errors?]
    :as   args}]
  (let [subscribe-field (fn [legacy-field]
                          @(rf/subscribe [::sub/field-value
                                          {:field        legacy-field
                                           :section-id   section-id
                                           :state-path   state-path
                                           :answers-path answers-path}]))
        rows (if (some? value)
               value
               (let [legacy-nationality (subscribe-field :person/nationality)
                     legacy-id (subscribe-field :person/national-identification-number)]
                 (when (or legacy-nationality
                           (not (cu/blank-value? legacy-id)))
                   [{:nationality legacy-nationality
                     :id-number   legacy-id}])))
        on-blur (fn [_e]
                  (rf/dispatch [::event/on-blur-field {:field      field
                                                       :state-path state-path}]))]
    [:div
     {:class "flex flex-col gap-4"}

     (when (and show-validation-errors?
                (map? validation-errors))
       [error-text/view
        {:validation-errors (:general validation-errors)}])

     (when (seq rows)
       [:div
        {:class "flex flex-col gap-4"}
        (->> rows
             (map-indexed
              (fn [index row]
                ^{:key (str "nationality-" index)}
                [nationality-row
                 (merge args
                        {:row                     row
                         :index                   index
                         :rows                    rows
                         :on-blur                 on-blur
                         :row-validation-errors   (get-in validation-errors [:items index])
                         :show-validation-errors? show-validation-errors?
                         :can-remove-row?         (not read-only?)})]))
             (doall))])

     (when-not read-only?
       [:div
        {:class "flex justify-start"}
        [button/sm-primary-solid
         {:on-click (fn [_]
                      (change-rows! args (concat rows [{}])))}
         [:i
          {:class "fal fa-plus"}]
         (loc/tr :add-nationality nil lang-kw)]])]))
